export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    isLoading() {
      return this.loading;
    },

    load() {
      this.loading = true;
      if (window.EventBus) {
        window.EventBus.$emit("toggle-loader", true);
      }
    },

    loadComplete() {
      this.loading = false;
      if (window.EventBus) {
        window.EventBus.$emit("toggle-loader", false);
      }
    },

    toggleLoader(loading) {
      this.loading = loading;
    }
  }
};
